import { supplierPaymentsService } from "@/services/suplpayments-api.service";

const ADD_FILES = 'addFiles';
const ADD_RECENT_FILE = 'addRecentFile'

const ADD_FILE_UPLOADS = 'addFileUploads';
const ADD_FILE_UPLOAD = 'addRecentFileUpload'

const ADD_WORKITEM_PROGRESS = 'addWorkItemFileProgress'
const ADD_WORKITEM_RECONCILIATION = 'addWorkItemFileReconciliation'
const ADD_WORKITEM_FILE_SCHEMAS = 'addWorkItemFileSchemas'
const UPDATE_WORKITEM_RECONCILIATION = 'updateWorkItemFileReconsiliation'
const UPDATE_WORKITEM_RECONCILIATION_BATCH = 'updateWorkItemFileReconsiliationBatch'
const UPDATE_WORKITEM_BATCH_STATUS = 'updateWorkItemFileBatchStatus'

const state = () => ({
    uploadedFiles: [],
    recentFiles: [],
    workItemFileSchemas: [],
    workItemFileProgress: [],
    workItemFileReconciliation: [],
    checkedBatchNumber: null,
    isBatchNumberValid: false
});

const actions = {
    checkBatchNumber({ commit }, payload) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .checkBatchNumber(payload)
                .then(response => {
                    console.log('-Response: ', response)
                    let { data: apiResponse } = response
                    //commit(ADD_RECENT_FILE_UPLOAD, apiResponse.uploads)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    batchItems({ commit }, payload) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .batchItems(payload)
                .then(response => {
                    console.log('-Response: ', response)
                    let { data: apiResponse } = response
                    commit(UPDATE_WORKITEM_RECONCILIATION_BATCH, apiResponse.data)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    addToBatch({ commit }, payload) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .addToBatch(payload)
                .then(response => {
                    console.log('-Response: ', response)
                    let { data: apiResponse } = response
                    commit(UPDATE_WORKITEM_RECONCILIATION_BATCH, apiResponse.data)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    uploadWorkItemFiles({ commit }, formData) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .uploadWorkItemFiles(formData)
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_FILE_UPLOAD, apiResponse.data)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    setWorkItemRowStatus({ commit }, payload) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .setWorkItemRowStatus(payload)
                .then(response => {
                    //console.log('-response: ', response)
                    let { data: apiResponse } = response
                    console.log('-apiResponse[0]: ', apiResponse[0])
                    commit(UPDATE_WORKITEM_RECONCILIATION, apiResponse[0])
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    setBatchStatus({ commit }, payload) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .setBatchToPaid(payload)
                .then(response => {
                    console.log('-response: ', response)
                    let { data: apiResponse } = response
                    commit(UPDATE_WORKITEM_BATCH_STATUS, apiResponse.data)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getWorkItemFiles({ commit }, formData) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .uploadWorkItemFileList()
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_FILES, apiResponse.uploads)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getWorkItemFilesProgress({ commit }, payload) {
        console.log('-getWorkItemFilesProgress.payload: ', payload)
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .getWorkItemFilesProgress(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_WORKITEM_PROGRESS, apiResponse)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    resetWorkItemFilesProgress({ commit }) {
        return new Promise((resolve, reject) => {
            try {
                commit(ADD_WORKITEM_PROGRESS, [])
                resolve([]);
            } catch (error) {
                reject(error);
            }
        });
    },
    getWorkItemFilesReconciliation({ commit }, payload) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .getWorkItemFileReconciliation(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_WORKITEM_RECONCILIATION, apiResponse.data)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getWorkItemFileSchemas({ commit }) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .getWorkItemFileSchemas()
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_WORKITEM_FILE_SCHEMAS, apiResponse.schemas)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getUploadedFiles({ commit }) {
        console.log('*********************** PING ***********************')
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .getUploadedFilesList()
                .then(response => {
                    let { data: apiResponse } = response
                    console.log('-response: ', response)
                    commit(ADD_FILE_UPLOADS, apiResponse.data)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
};
const getters = {
    getRecentFiles: state => state.recentFiles,
    getWorkItemFileSchemas: state => state.workItemFileSchemas,
    getWorkItemFileProgress: state => state.workItemFileProgress,
    getWorkItemFileReconciliation: state => state.workItemFileReconciliation,
    getUploadedFiles: state => state.uploadedFiles
};
const mutations = {
    [ADD_FILES](state, payload) {
        state.recentFiles = [...(payload || [])]
    },
    [ADD_RECENT_FILE](state, payload) {
        state.recentFiles = [...(payload || []), ...(state.recentFiles || [])]
    },
    [ADD_WORKITEM_PROGRESS](state, payload) {
        console.log('-p: ', payload)
        state.workItemFileProgress = [...(payload || [])]
    },
    [ADD_WORKITEM_RECONCILIATION](state, payload) {
        console.log('-p: ', payload)
        state.workItemFileReconciliation = payload
    },
    [ADD_WORKITEM_FILE_SCHEMAS](state, payload) {
        console.log('-payload: ', payload)
        state.workItemFileSchemas = [...(payload || [])]
    },
    [ADD_FILE_UPLOADS](state, payload) {
        state.uploadedFiles = [...(payload || [])]
    },
    [ADD_FILE_UPLOAD](state, payload) {
        state.uploadedFiles = [...(payload || []), ...(state.uploadedFiles || [])]
    },
    [UPDATE_WORKITEM_RECONCILIATION](state, payload) {
        const arr = state.workItemFileReconciliation.items
        console.log('-arr: ', arr)
        const idx = arr.findIndex(i => i.supplierWorkItemImportRowId == payload.supplierWorkItemImportRowId)
        console.log('-idx: ', idx)
        if (idx !== -1)
            state.workItemFileReconciliation.items.splice(idx, 1, payload)
    },
    [UPDATE_WORKITEM_RECONCILIATION_BATCH](state, payload) {
        console.log('-payload: ', payload)
        const arr = state.workItemFileReconciliation.items
        payload.forEach(b => {
            const idx = arr.findIndex(i => i.supplierWorkItemImportRowId == b.id)

            const updatedItem = {
                ...arr[idx],
                batchNumber: b.batchNumber,  // update the batchId field
            };
            // Replace the element at idx
            state.workItemFileReconciliation.items.splice(idx, 1, updatedItem);

        })
    },
    [UPDATE_WORKITEM_BATCH_STATUS](state, payload) {
        console.log('-p: ', payload);

        const updatesMap = Object.fromEntries(
            (payload || []).map(b => [b.id, b])
        );

        const newData = state.workItemFileProgress.map(file => ({
            ...file,
            batches: (file.batches || []).map(batch =>
                updatesMap[batch.id] || batch
            )
        }));

        state.workItemFileProgress = newData;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}